import noUiSlider from 'nouislider';
import { __ } from '../helpers/i18n';
export function rangeTrigger() {
    const containers = document.querySelectorAll('.range-trigger');
    if (!containers.length)
        return;
    containers.forEach(container => {
        const slider = container.querySelector('.range-slider');
        const minBox = container.querySelector('.range-min');
        const maxBox = container.querySelector('.range-max');
        const minValueBox = container.querySelector('.range-min-value');
        const maxValueBox = container.querySelector('.range-max-value');
        const inputMin = minBox.min ? parseInt(minBox.min) : 0;
        const inputMax = minBox.max ? parseInt(minBox.max) : Infinity;
        const step = minBox.step ? parseInt(minBox.step) : 1;
        noUiSlider.create(slider, {
            start: [
                minBox.value && minBox.value != inputMin.toString() ? minBox.value : inputMin,
                maxBox.value && maxBox.value != inputMax.toString() ? maxBox.value : inputMax
            ],
            connect: true,
            step: step,
            range: {
                'min': inputMin,
                'max': inputMax
            },
            format: {
                to: value => {
                    return value.toFixed();
                },
                from: value => {
                    return Number(value);
                }
            }
        });
        slider.noUiSlider.on('update', (values, handle) => {
            const newValue = values[handle].toString();
            if (handle === 0) {
                minBox.value = values[handle] == inputMin ? '' : newValue;
                if (minValueBox)
                    minValueBox.textContent = newValue;
            }
            else {
                maxBox.value = values[handle] == inputMax && minBox.value === '' ? '' : newValue;
                if (maxValueBox)
                    maxValueBox.textContent = newValue;
            }
        });
        minBox.addEventListener('change', function () {
            slider.noUiSlider.set([this.value, null]);
        });
        maxBox.addEventListener('change', function () {
            slider.noUiSlider.set([null, this.value]);
        });
        const lowerHandle = slider.querySelector('.noUi-handle-lower');
        const lowerUpper = slider.querySelector('.noUi-handle-upper');
        lowerHandle.ariaLabel = __('Minimalna wartość');
        lowerUpper.ariaLabel = __('Maksymalna wartość');
    });
}
